module.exports = __webpack_public_path__ + "static/img/grade_10.e3e09a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_10.png
// module id = lqJX
// module chunks = 89